import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Input as AriaInput } from "react-aria-components";
import { InputBuilder } from "./shared/InputBuilder.js";
import { extractInputBuilderProps } from "./shared/inputBuilderHelper.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseInput = (props, ref) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props) {
    t0 = extractInputBuilderProps(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    inputBuilderProps,
    restProps
  } = t0;
  let t1;
  if ($[2] !== ref || $[3] !== restProps) {
    t1 = /*#__PURE__*/_jsx(AriaInput, {
      ref: ref,
      ...restProps
    });
    $[2] = ref;
    $[3] = restProps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== inputBuilderProps || $[6] !== t1) {
    t2 = /*#__PURE__*/_jsx(InputBuilder, {
      ...inputBuilderProps,
      children: t1
    });
    $[5] = inputBuilderProps;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const Input = /*#__PURE__*/React.forwardRef(BaseInput);
//# sourceMappingURL=Input.js.map